import { getState } from './state';

export const SITE_LAST_RELOAD_TIME_STATE_KEY = 'site:last-reload-time';

/**
 * Get the site's last reload time
 * @return {String} the site's last reload time
 */
export const getSiteLastReloadTime = () => getState(SITE_LAST_RELOAD_TIME_STATE_KEY);
